import { computed } from '@vue/composition-api';
import { HomeBanner, JumpType } from '@/types/home';

/**
 * 获取jumpInfo数据
 */
export function useJumpInfo(banner: HomeBanner|undefined) {
  const jumpInfo = computed(() => {
    if (!banner) {
      return {};
    }
    const { jumpType, appid, username, path, jumpUrl } = banner;
    if (jumpType === JumpType.MiniProgram) {
      return {
        appid,
        username,
        path,
      };
    }
    return {
      jumpUrl,
    };
  });
  return {
    jumpInfo,
  };
}
